import '@omnitracs/walkme-component';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { NotSignedInError } from '@ot/shared/utils';
import * as __NgCli_bootstrap_1 from "./app/app.module.ngfactory";
import * as __NgCli_bootstrap_2 from "@angular/platform-browser";
if (environment.production) {
    enableProdMode();
}
__NgCli_bootstrap_2.platformBrowser()
    .bootstrapModuleFactory(__NgCli_bootstrap_1.AppModuleNgFactory)
    .catch(err => {
    //NotSignedInError is thrown if the app is loaded at first and user is not signed in
    //it should not be an app error so we do not want to log it.
    if (!(err instanceof NotSignedInError)) {
        console.error(err);
    }
});
